import { createSlice } from '@reduxjs/toolkit';

const versionSlice = createSlice({
  name: 'version',
  initialState: {
    value: '0.0.0',
  },
  reducers: {
    setVersion: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setVersion } = versionSlice.actions;
export default versionSlice.reducer;